import React from 'react';
import { motion } from 'framer-motion';
import hackenProofImage from '../../assets/proofed-by-hacken.webp';

const Web3Audit = () => {
  return (
    <section className="py-20 bg-white">
      <div className="section-container">
        {/* Hacken Audit Section - 2 Column Layout */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center mb-16"
        >
          {/* Left Column - Hacken Image */}
          <div className="flex justify-center lg:justify-start">
            <img 
              src={hackenProofImage} 
              alt="Proofed by Hacken - Smart Contract Audit" 
              className="w-full max-w-md lg:max-w-lg h-auto object-contain rounded-2xl"
            />
          </div>

          {/* Right Column - Audit Score Text */}
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              Audited with a 10/10 score.
            </h2>
            <p className="text-lg lg:text-xl text-gray-600 mb-8 leading-relaxed">
              The Blockfirst Capital Web3 Wallet's smart contracts passed the independent Hacken audit with a 10/10 score to meet the highest blockchain security standards.
            </p>
          </div>
        </motion.div>

        <div className="space-y-12">

          {/* Create your non-custodial Web3 wallet Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              Create your non-custodial Web3 wallet.
            </h3>
            
            {/* Features List */}
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <svg className="w-5 h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <span className="font-medium text-gray-900">Self-custody of assets</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <svg className="w-5 h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                  </svg>
                </div>
                <span className="font-medium text-gray-900">Secure private keys</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <svg className="w-5 h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <span className="font-medium text-gray-900">Secure offline transactions</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <svg className="w-5 h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <span className="font-medium text-gray-900">Decentralized data storage</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Web3Audit; 